import {
	getVehicles,
	setVehicles
} from '@/utils/auth'
import Cookies from 'js-cookie'
import {
	EventBus
} from "@/utils/event-bus.js";
const state = {
	mapConfig: {
		mapCenter: '116.405,39.920', //'117.971474,24.590842',//地图默认显示的经纬度，可以修改
		mapZoom: 15
	},
	sidebar: {
		opened: true
	},
	vehicles: {
		data: [],
		tree: {},
		rootId: "",
		selectedVehicles: [], //选中的车辆
	},
	size: "small", //mini small  medium 
	socketConnect: false,
	locale: Cookies.get("longyi-lang") || 'zh-cn',
	mapType: Cookies.get("longyi-map-type") || 'baidu', //地图类型
	mapKey: Cookies.get("longyi-map-key") || 'gwHUx2BXdkIw9nbsMA0GUAbVY55kYEVx', //地图key
	inspectionQuery: {
		searchTime: [], // 存储查询时间范围
		form: {} // 存储完整查询条件
	}
}

const mutations = {
	//切换地图类型
	changeMapType(state, mapType) {
		state.mapType = mapType;
		Cookies.set("longyi-map-type", mapType);

	},
	//切换地图key
	changeMapKey(state, mapKey) {
		state.mapKey = mapKey;
		Cookies.set("longyi-map-key", mapKey);
	},
	//切换语言
	changeLocale(state, locale) {
		state.locale = locale;
		Cookies.set("longyi-lang", locale);

	},
	CONNECT_SOCKET: (state) => {
		console.log("CONNECT_SOCKET")
		state.socketConnect = true
	},
	DISCONNECT_SOCKET: (state) => {

		state.socketConnect = false
	},
	TOGGLE_SIDEBAR: state => {
		state.sidebar.opened = !state.sidebar.opened

	},
	CLOSE_SIDEBAR: (state) => {
		state.sidebar.opened = false
	},
	OPEN_SIDEBAR: (state) => {

		state.sidebar.opened = true
	},
	UPDATE_VEHICLEDATA: (state, data) => {
		console.log("UPDATE_VEHICLEDATA")
		state.vehicles.data = data
	},
	UPDATE_VEHICLETREE: (state, {
		tree,
		rootId
	}) => {
		console.log("UPDATE_VEHICLETREE")
		state.vehicles.tree = tree
		state.vehicles.rootId = rootId
	},
	UPDATE_VEHICLEONLINE: (state, {
		id,
		online
	}) => {
	
		if (state.vehicles.tree[id]) {
			
			state.vehicles.tree[id].isOnLine = online
		}


	},
	UPDATE_VEHICLEGROUP: (state, {
		vids,
		groupid
	}) => {
		console.log("UPDATE_VEHICLEGROUP")
		if (vids) {
			vids = "," + vids + ","
			var v = getVehicles()

			if (v && v != "") {
				var vlist = JSON.parse(v);
				vlist.forEach(d => {
					if (vids.indexOf(("," + d.nodeValue + ",")) > -1) {
						d.pId = groupid;
					}
				});
				setVehicles(JSON.stringify(vlist));

				var tree = {};
				vlist.forEach(element => {
					element.isChecked = false;
					tree[element.id] = element;
				});
				state.vehicles.tree = tree
				state.vehicles.rootId = vlist[0].id
				state.vehicles.data = vlist

				EventBus.$emit("initVehicleTree");
			}


			// var arr = vids.split(',');
			// arr.forEach(element => {
			//     if (state.vehicles.tree["C"+element]!=undefined){
			//         console.log("C"+element)
			//         console.log(state.vehicles.tree["C"+element])
			//         state.vehicles.tree["C"+element].pId = groupid
			//     }
			// });
		}

	},

	UPDATE_SELECTEDVEHICLES: (state, data) => {
		var result = [];
		for (var i in data) {
			result.push(data[i]);
		}
		state.vehicles.selectedVehicles = result

	},
	UPDATE_LANGUAGES: (state, lang) => {
		Cookies.set("longyi-lang", lang)
		state.locale = lang

	},
	SET_INSPECTION_QUERY(state, data) {
		state.inspectionQuery = {
			...state.inspectionQuery,
			...data
		};
	},
	CLEAR_INSPECTION_QUERY(state) {
		state.inspectionQuery = {
			searchTime: [],
			form: {}
		};
	}


}


const actions = {
	//切换地图类型
	changeMapType({
		commit
	}, mapType) {
		commit("changeMapType", mapType);
	},
	//切换地图key
	changeMapKey({
		commit
	}, mapKey) {
		commit("changeMapKey", mapKey);
	},
	//切换语言
	changeLocale({
		commit
	}, locale) {
		commit("changeLocale", locale);
	},
	connectSocket({
		commit
	}) {
		console.log("connectSocket")
		commit('CONNECT_SOCKET')
	},
	disConnectSocket({
		commit
	}) {
		commit('DISCONNECT_SOCKET')
	},
	toggleSideBar({
		commit
	}) {
		commit('TOGGLE_SIDEBAR')
	},
	closeSideBar({
		commit
	}) {
		commit('CLOSE_SIDEBAR')
	},
	openSideBar({
		commit
	}) {
		commit('OPEN_SIDEBAR')
	},
	updateVehicleData({
		commit
	}, data) {
		commit('UPDATE_VEHICLEDATA', data)
	},
	updateVehicleTree({
		commit
	}, {
		tree,
		rootId
	}) {
		commit('UPDATE_VEHICLETREE', {
			tree,
			rootId
		})
	},
	updateVehicleOnline({
		commit
	}, {
		id,
		online
	}) {
		commit('UPDATE_VEHICLEONLINE', {
			id,
			online
		})
	},
	updateVehicleGroup({
		commit
	}, {
		vids,
		groupid
	}) {
		commit('UPDATE_VEHICLEGROUP', {
			vids,
			groupid
		})
	},

	updateSelectedVehicles({
		commit
	}, data) {
		commit('UPDATE_SELECTEDVEHICLES', data)
	},
	//    clearSelectedVehicles({ dispatch }, data) {

	//         dispatch('updateSelectedVehicles', data)



	//     },
	updateLanguages({
		commit
	}, lang) {
		commit('UPDATE_LANGUAGES', lang)
	},
	setInspectionQuery({
		commit
	}, data) {
		commit('SET_INSPECTION_QUERY', data);
	},
	clearInspectionQuery({
		commit
	}) {
		commit('CLEAR_INSPECTION_QUERY');
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}